import { alpha } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export const MuiToggleButtonGroupConfig = {
    defaultProps: {
        size: 'medium',
    },
    styleOverrides: {
        root: ({ theme }: { theme: any }) => {
            return {
                alignSelf: 'baseline',
                whiteSpace: 'nowrap',
                '&.design-variant--secondary': {
                    backgroundColor: useBlendColors(alpha(theme.palette.text.primary, 0.04)),
                    borderRadius: '4px',
                    padding: '3px',
                    '&.MuiToggleButtonGroup-horizontal': {},
                    '.MuiToggleButtonGroup-groupedHorizontal': {},
                    '&.MuiToggleButtonGroup-vertical': {},
                    '.MuiToggleButtonGroup-groupedVertical': {},
                },
            };
        },
        grouped: ({ theme }: { theme: any }) => {
            return {
                width: '100%',
            };
        },
    },
};
